var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.addressChecked)?_c('AddressCheckerResults',{staticClass:"mb-5",attrs:{"available":_vm.availableForDelivery,"postcode":_vm.postcode,"price":_vm.deliveryPrice}}):_c('ProductAddressChecker',{attrs:{"shipping-class":_vm.shippingClassId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }